import { useImmer } from "use-immer";
import { useEffect } from "react";
import UtilService from "../../service/UtilService";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesRight,
  faAnglesLeft,
  faAngleUp,
  faAngleDown,
} from "@fortawesome/free-solid-svg-icons";

const LOCAL_STORAGE_NAME = "auditlogDisplayedColumns";

const DEFAULT_DISPLAYED = [
  "eventType",
  "created",
  "userId",
  "newValue",
  "oldValue",
  "actions",
];

const AVAILABLE_ATTRIBUTES = [
  "id",
  "eventType",
  "created",
  "userId",
  "oldValue",
  "newValue",
  "description",
  "targetType",
  "action",
  "actions",
];

const AuditlogColumnConfigurator = ({ onChange }) => {
  const [displayed, updateDisplayed] = useImmer([]);
  const [displayable, updateDisplayable] = useImmer([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAME));

    if (stored && Array.isArray(stored) && stored.length > 0) {
      updateDisplayed(stored);
    } else {
      updateDisplayed(DEFAULT_DISPLAYED);
      localStorage.setItem(
        LOCAL_STORAGE_NAME,
        JSON.stringify(DEFAULT_DISPLAYED),
      );
    }
  }, []);

  useEffect(() => {
    const remaining = AVAILABLE_ATTRIBUTES.filter(
      (k) => !displayed.includes(k),
    );
    updateDisplayable(remaining);
  }, [displayed]);

  useEffect(() => {
    if (displayed.length > 0) {
      onChange(displayed);
      localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(displayed));
    }
  }, [displayed]);

  const moveRight = (idx) => {
    const attr = displayable[idx];
    updateDisplayed([...displayed, attr]);
    updateDisplayable(displayable.filter((_, i) => i !== idx));
  };

  const moveLeft = (idx) => {
    const attr = displayed[idx];
    updateDisplayable([...displayable, attr].sort());
    updateDisplayed(displayed.filter((_, i) => i !== idx));
  };

  const moveUp = (idx) => {
    if (idx === 0) return;
    updateDisplayed((draft) => {
      [draft[idx - 1], draft[idx]] = [draft[idx], draft[idx - 1]];
    });
  };

  const moveDown = (idx) => {
    if (idx >= displayed.length - 1) return;
    updateDisplayed((draft) => {
      [draft[idx + 1], draft[idx]] = [draft[idx], draft[idx + 1]];
    });
  };

  const maxRows = Math.max(displayable.length, displayed.length);

  return (
    <table className="config-table">
      <thead>
        <tr>
          <th>Displayable attributes</th>
          <th>Displayed attributes</th>
        </tr>
      </thead>

      <tbody>
        {Array.from({ length: maxRows }).map((_, idx) => (
          <tr className="trnohover" key={idx}>
            {/* Displayable */}
            <td>
              {displayable[idx] && (
                <>
                  {UtilService.camelCaseToReadable(displayable[idx])}
                  <span className="float-right">
                    <FontAwesomeIcon
                      icon={faAnglesRight}
                      className="icon-clickable"
                      onClick={() => moveRight(idx)}
                    />
                  </span>
                </>
              )}
            </td>

            {/* Displayed */}
            <td>
              {displayed[idx] && (
                <>
                  {UtilService.camelCaseToReadable(displayed[idx])}
                  <span className="float-right">
                    <FontAwesomeIcon
                      icon={faAnglesLeft}
                      className="icon-clickable"
                      onClick={() => moveLeft(idx)}
                    />
                    &nbsp;&nbsp;
                    <FontAwesomeIcon
                      icon={faAngleUp}
                      className={
                        idx > 0 ? "icon-clickable" : "icon-disabled"
                      }
                      onClick={() => moveUp(idx)}
                    />
                    &nbsp;&nbsp;
                    <FontAwesomeIcon
                      icon={faAngleDown}
                      className={
                        idx < displayed.length - 1
                          ? "icon-clickable"
                          : "icon-disabled"
                      }
                      onClick={() => moveDown(idx)}
                    />
                  </span>
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AuditlogColumnConfigurator;
